<template>
	<div>
		<div>
			<h2 class="mb-4 font-bold">{{ type }} {{ $t('Roles') }}</h2>

			<div class="mb-4">
				<label class="block mb-2" for="rol">{{ $t('Nombre') }}</label>
				<input
					type="text"
					v-model="rol.rol"
					id="rol"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				/>
				<div v-if="$v.rol.rol.$dirty">
					<div class="text-sm text-red-500 mt-2" v-if="!$v.rol.rol.required">
						{{ $t('name_required') }}
					</div>
					<div class="text-sm text-red-500 mt-2" v-if="!$v.rol.rol.maxLength">
						{{ $t('name_validation') }}
					</div>
				</div>
			</div>

			<div class="mb-4">
				<label class="block mb-2" for="currentcountry">País</label>
				<select
					ref="currentcountry"
					id="currentcountry"
					v-model="rol.country_id"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				>
					<option
						v-for="(country, index) in countries"
						:value="country.id"
						:key="index"
						:selected="country.id == rol.country_id"
					>
						{{ country.name }}
					</option>
				</select>
			</div>

			<div class="mb-4">
				<label class="block mb-2" for="category">{{
					$t('Administrador')
				}}</label>
				<toggle-button
					v-model="rol.is_administrator"
					color="#68ace1"
					:sync="true"
				/>
			</div>

			<div class="mb-4">
				<label class="block mb-2" for="category">{{
					$t('contratacion')
				}}</label>
				<toggle-button
					v-model="rol.allow_hiring"
					color="#68ace1"
					:sync="true"
				/>
			</div>

			<label>{{ $t('Base_comercial') }}</label>
			<dual-list
				v-if="DualListOptions"
				id="vueduallist"
				:options="DualListOptions"
			/>

			<div class="flex mt-4 justify-end">
				<ButtonBlack @click.native="submit">
					<div v-if="loading">
						<pulse-loader
							:loading="loading"
							:color="'#fff'"
							:size="'10px'"
						></pulse-loader>
					</div>
					<div v-else>
						{{ buton_text }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</div>
</template>

<script>
import DualList from '@/components/DualList.vue'
import { required, maxLength } from 'vuelidate/lib/validators'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { single } from '@/mixins'
import { ToggleButton } from 'vue-js-toggle-button'
import { fetchRole, insertRole, updateRole } from '@/apollo/roles'
import { fetchCountriesSelect } from '@/apollo/countries'
import { fetchCommercialBaseList } from '@/apollo/commercialBase'

export default {
	mixins: [single],
	components: {
		DualList,
		PulseLoader,
		ToggleButton
	},
	data() {
		return {
			rol: {
				rol: null,
				country_id: null,
				is_administrator: false,
				allow_hiring: false
			},
			countries: [],
			commercial_base: null
		}
	},
	apollo: {
		rol() {
			const query = fetchRole(this.id)
			query.skip = this.id == null
			return query
		},
		countries: fetchCountriesSelect(),
		commercial_base: fetchCommercialBaseList()
	},
	watch: {
		commercial_base: function (data) {
			if (this.rol.commercial_base != null && this.DualListOptions === null) {
				this.loadCommercialBaseList(data, this.rol.commercial_base)
			}
		},
		rol: function (data) {
			if (
				this.id != null &&
				this.commercial_base != null &&
				this.DualListOptions === null
			) {
				this.loadCommercialBaseList(this.commercial_base, data.commercial_base)
			}
		}
	},
	methods: {
		loadCommercialBaseList(commercial_base, selected) {
			this.loadDualList(
				commercial_base,
				selected
					? selected
							.map(org => commercial_base.find(elem => elem.id == org.id))
							.filter(elem => elem != null)
					: selected
			)
		},
		getRolesData() {
			return {
				rol: this.rol.rol,
				country_id: this.rol.country_id,
				is_administrator: this.rol.is_administrator,
				allow_hiring: this.rol.allow_hiring
			}
		},
		submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				this.$apollo
					.mutate(
						this.id
							? updateRole(
									this.id,
									this.getRolesData(this.rol),
									this.DualListOptions.selectedItems
							  )
							: insertRole(
									this.getRolesData(this.rol),
									this.DualListOptions.selectedItems
							  )
					)
					.then(() => this.stopLoadingState())
					.catch(error => this.setError(error))
			} else {
				this.setError(this.$t('form_validation'))
			}
		}
	},
	validations() {
		return {
			rol: {
				rol: {
					required,
					maxLength: maxLength(50)
				},
				country_id: {
					required
				}
			}
		}
	}
}
</script>
